import { isHomePage } from "../utils/isHomePage";

function throttle(mainFunction, delay) {
  let timerFlag = null;
  return (...args) => {
    if (timerFlag === null) {
      mainFunction(...args);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
}

function initUniqueLinks() {
  const bottomLinks = document.querySelectorAll(".bottom-link-container");

  if (bottomLinks.length > 0) {
    const toggleVisibility = (item) => {
      const rect = item.getBoundingClientRect();
      const isInViewport =
        rect.top >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight);

      if (isInViewport) {
        item.classList.remove("link-hidden");
        item.classList.add("link-visible");
      } else {
        item.classList.remove("link-visible");
        item.classList.add("link-hidden");
      }
    };

    // Initialize styles
    bottomLinks.forEach((link) => {
      link.classList.add("link-hidden");
    });

    // Attach a separate throttled function for each link
    const throttledFunctions = Array.from(bottomLinks).map((link) =>
      throttle(() => toggleVisibility(link), 100)
    );

    // Attach the scroll event listener
    window.addEventListener("scroll", () => {
      throttledFunctions.forEach((fn) => fn());
    });

    // Initial check
    bottomLinks.forEach((link) => toggleVisibility(link));
  }
}

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", initUniqueLinks);

// Initialize on dynamic content load if on homepage
if (isHomePage()) {
  document.addEventListener("bottomContentLoaded", initUniqueLinks);
}
